module.exports = __webpack_public_path__ + "static/media/again.6d97d23a.svg";